<template>
    <aside class="menu" v-scroll-lock="isLocked">
        <Heading :h="3" size="xl">
            {{ siteContent.menu }}
        </Heading>
        <SettingsList/>
        <FeaturedTiles/>
    </aside>
</template>

<script>
    import SettingsList  from '@/components/layout/header/SettingsList'
    import FeaturedTiles from '@/components/layout/header/FeaturedTiles'

    export default {
        name: 'Menu',
        components: {
            SettingsList,
            FeaturedTiles
        },
        computed: {
            isLocked() {
                if(window.matchMedia("(max-width: 800px)").matches) {
                    return true
                }
            }
        }
    }
</script>


<style scoped lang="scss">
    @import '../../../scss/variables';

    .menu {
        position: fixed;
        top: 4rem;
        right: 2rem;
        max-height: calc(100vh - 4rem);
        max-width: 32rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        background: var(--color-grey-100);
        border-radius: 1rem;
        z-index: 2;
        padding: 1.5rem;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    .h3 {
        margin: 0 0 1rem 0;
    }

    @media all and (max-width: 1200px) {
        .menu {
            width: 100%;
            top: 3.5rem;
            right: 0;
        }
    }

    @media all and (max-width: 560px) {
        .menu {
            max-width: 100%;
            top: 0;
            padding-top: 4rem;
            z-index: -1;
            height: calc(100vh - 3rem);
            border-radius: 0;
            padding-bottom: calc(4rem + env(safe-area-inset-bottom));
        }
    }
</style>